export default "__VITE_ASSET__3ddb331a__"